import React, { useState } from "react";
import Icon from "./Icon";

/**
 * Click-to-play YouTube frame. Nothing from YouTube loads until the visitor
 * asks for it, which keeps first paint fast and avoids autoplaying video.
 */
const VideoFrame = ({ id, title, poster, className = "" }) => {
  const [playing, setPlaying] = useState(false);
  const thumb = poster || `https://i.ytimg.com/vi/${id}/maxresdefault.jpg`;

  return (
    <div
      className={`relative aspect-video w-full overflow-hidden rounded-lg border border-line bg-surface-2 ${className}`}
    >
      {playing ? (
        <iframe
          className="absolute inset-0 h-full w-full"
          src={`https://www.youtube.com/embed/${id}?autoplay=1&rel=0&modestbranding=1`}
          title={title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        />
      ) : (
        <button
          type="button"
          onClick={() => setPlaying(true)}
          className="group absolute inset-0 h-full w-full cursor-pointer"
          aria-label={title}
        >
          <img
            src={thumb}
            alt=""
            loading="lazy"
            className="h-full w-full object-cover"
            onError={(event) => {
              event.currentTarget.src = `https://i.ytimg.com/vi/${id}/hqdefault.jpg`;
            }}
          />
          <span className="absolute inset-0 bg-[rgba(16,14,11,.28)] transition-colors duration-200 group-hover:bg-[rgba(16,14,11,.42)]" />
          <span className="absolute left-1/2 top-1/2 flex h-14 w-14 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-paper text-ink shadow-raise transition-transform duration-200 ease-out group-hover:scale-105">
            <Icon name="play" size={20} className="translate-x-[1px]" />
          </span>
        </button>
      )}
    </div>
  );
};

export default VideoFrame;
